import type {ReactNode} from 'react'
import {useTranslation} from 'react-i18next'
import {Tag} from '@/components/ui/tag'

/** Para 1 a 3 datos sueltos; 4 o más relacionados van en `FichaDatos`, que pone el encabezado. */
export function Fact({label, children}: {label: string; children: ReactNode}) {
  return (
    // min-w-0: como ítem de grilla, un valor largo sin cortes desbordaría la tarjeta.
    <div className="min-w-0 space-y-1">
      <p className="font-mono text-[10px] font-medium tracking-wider text-muted-foreground uppercase">{label}</p>
      <div className="text-sm text-foreground">{children}</div>
    </div>
  )
}

export function Eyebrow({children}: {children: ReactNode}) {
  return (
    <p className="mb-2.5 font-mono text-[10px] font-medium tracking-wider text-muted-foreground uppercase">
      {children}
    </p>
  )
}

export function TagList({names}: {names: string[]}) {
  const {t} = useTranslation()
  if (names.length === 0) return <span className="text-muted-foreground">{t('perfil.none')}</span>
  return (
    <span className="flex flex-wrap gap-1">
      {names.map((name) => (
        <Tag key={name} tone="neutral">
          {name}
        </Tag>
      ))}
    </span>
  )
}
